
<template>

  <v-data-table item-key="SubCategoryID" :single-expand="singleExpand" :expanded.sync="expanded" :loading="loading"
    hide-default-header :headers="headers" :items="Category" :sort-by="sortBy" hide-default-footer
    :items-per-page="Category.length">
    <template v-slot:item="{ item, isExpanded, expand }">
      <tr class="pointer">
        <td class="text-left small-td pointer">
          <v-layout row align-center>
            <v-flex shrink>
              <v-btn @click="expand(true)" icon v-if="!isExpanded">
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
              <v-btn @click="expand(false)" icon v-if="isExpanded">
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <div>{{ item.SubCategoryName }}</div>
              <div class="font-italic caption" v-if="showMainCategory">- {{ item.MainCategoryName }}</div>
            </v-flex>
          </v-layout>

        </td>

        <td class="text-center small-td pointer">{{ parseInt(item.Quantity) }}</td>
        <td class="text-right small-td pointer">{{ item.SaleAmount | currency }}</td>
        <td class="text-right small-td pointer">{{ item.CostAmount | currency }}</td>
        <td class="text-right small-td pointer">{{ item.DetailDiscount | currency }}</td>
        <td :class="foreColor(item.profit)" class="text-right small-td pointer">{{ item.profit | currency }}</td>
      </tr>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-0" :key="item.SubCategoryID">
        <v-card color="grey lighten-3" tile light>
          <v-card-text>
            <ProductList :dateTime="dateTime" :location="location" :subCategory="item.SubCategoryID" />
          </v-card-text>
        </v-card>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex'
import reportService from '@/pages/Report/service.js'
import ProductList from '@/pages/Report/components/ProductList.vue'

export default {
  name: 'category-list',
  props: ['dateTime', 'showMainCategory', 'location', 'mainCategory'],
  data() {
    return {
      expanded: [],
      singleExpand: true,
      loading: false,
      Category: [],
      sortBy: "SubCategoryName",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Name',
          align: "left",
          sortable: true,
          value: "SubCategoryName"
        },
        {
          text: 'Quantity',
          align: "center",
          sortable: true,
          value: "Quantity"
        },
        {
          text: 'Sale Amount',
          align: "right",
          sortable: true,
          value: "SaleAmount"
        },

        {
          text: 'Cost of goods',
          align: 'right',
          value: "CostAmount",
          sortable: true
        },
        {
          text: 'Discount',
          align: 'right',
          value: "DetailDiscount",
          sortable: true
        },
        {
          text: 'Profit',
          align: 'right',
          value: "profit",
          sortable: true
        },

      ],
    }
  },
  components: {
    ProductList
  },
  watch: {
    location(val) {
      // this.setSelectedLocation(val)
      this.getSubCategory()
    }
  },
  created() {
    this.getSubCategory()
    // console.log('$route.params', this.$route.params)
    // if (this.$route.params.location) {
    //   this.location = this.$route.params.location
    //   this.dateTime = this.$route.params.dateTime
    //   this.mainCategory = this.$route.params.category.MainCategoryID

    //   this.getSubCategory()
    // } else {
    //   if (this.selectedLocation) {
    //     this.location = this.selectedLocation
    //   }
    // }
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation']),
    foreColor(val) {
      let color = 'white--text'
      if (val < 0) {
        color = 'red--text'
      }
      return color
    },
    getSubCategory() {
      this.Category = []
      this.loading = true

      const param = {
        mainCategory: 'NULL',
        from: this.dateTime.start.split("T")[0],
        to: this.dateTime.end.split("T")[0]
      }
      if (this.mainCategory) {
        param.mainCategory = this.mainCategory
      }
      console.log('param', param)
      return reportService
        .getSubCategory(this.location.storeID, param)
        .then(response => {
          console.log("getInvoiceList this one", response);
          this.loading = false
          this.Category = response.data
          this.Category.map(row => {
            row.profit = parseFloat(row.SaleAmount) - parseFloat(row.CostAmount) - parseFloat(row.DetailDiscount)
          })
          // this.setBatchList(this.Batches)
          return response;
        }).catch(error => {
          this.loading = false
        })

    }
  }
}
</script>

<style scoped>
</style>